<div [attr.id]="gridName ? gridName : 'form-grid'" style="max-height: 347px">
  <div class="kl-loading" *ngIf="loading">
    <div class="indicator">
      <div class="sk-three-bounce">
        <div class="sk-child sk-bounce1"></div>
        <div class="sk-child sk-bounce2"></div>
        <div class="sk-child sk-bounce3"></div>
      </div>
    </div>
    <div class="indicator-text">
      <ng-content></ng-content>
    </div>
  </div>
  <wj-flex-grid
    #flexGrid
    [itemsSource]="collectionView"
    [isReadOnly]="isReadOnly"
    [wjContextMenu]="formGridMenu"
    (initialized)="columnChange(flexGrid)"
    (lostFocus)="gridLostFocus(flexGrid)"
    (beginningEdit)="cellEdit(flexGrid, $event)"
    (keydown)="keyDown(flexGrid, $event)"
    (keydown.control.Home)="firstRow($event, flexGrid)"
    (keydown.control.End)="endRow($event, flexGrid)"
    (keydown.control.Help)="onAddNew.emit(flexGrid)"
    (keydown.control.Insert)="onAddNew.emit(flexGrid)"
    (keydown.control.Backspace)="
      deleteRow(flexGrid, collectionView.currentItem)
    "
    (keydown.control.Delete)="deleteRow(flexGrid, collectionView.currentItem)"
    [allowDragging]="'Columns'"
    [allowSorting]="false"
    [allowResizing]="allowResizing ? allowResizing : 'Both'"
    [showErrors]="showErrors ? showErrors : false"
    [validateEdits]="validateEdits ? validateEdits : false"
    [deferResizing]="deferResizing ? deferResizing : false"
  >
    <ng-template
      wjFlexGridCellTemplate
      [cellType]="'TopLeft'"
      style="max-width: 30px"
      *ngIf="gridName"
    >
      <div class="btn-group" dropdown container="body">
        <button
          class="btn p-0"
          style="color: #9e9e9e; background-color: transparent; outline: none"
          type="button"
          aria-haspopup="true"
          aria-expanded="true"
          container="body"
        >
          <i class="fal fa-cog" (click)="openSidebar()"></i>
        </button>
      </div>
    </ng-template>
    <wj-flex-grid-column
      *ngFor="let column of columns; let i = index"
      [visible]="!column?.visible"
      [header]="column?.header | translate"
      [name]="column?.name"
      [binding]="column?.binding"
      [dataMap]="column?.dataMap"
      [showDropDown]="column?.showDropDown"
      [isReadOnly]="column?.isReadOnly"
      [width]="column?.width ? column?.width : '*'"
      [cssClass]="column.cssClass"
      [format]="column?.format"
      [maxLength]="column?.maxLength"
      [isRequired]="column?.isRequired"
      (lostFocus)="columnLostFocus(flexGrid, i)"
    >
      <ng-template
        wjFlexGridCellTemplate
        [cellType]="'Cell'"
        let-cell="cell"
        *ngIf="column?.format === 'date'"
      >
        {{ cell.item[column.binding] | klDate }}
      </ng-template>
      <ng-template
        wjFlexGridCellTemplate
        [cellType]="'CellEdit'"
        let-cell="cell"
        *ngIf="column?.format === 'date'"
      >
        <wj-input-date
          [(value)]="cell.value"
          [isRequired]="false"
          [format]="'dd.MM.yyyy'"
          (valueChange)="cell.value = $event"
        ></wj-input-date>
      </ng-template>
      <ng-template
        wjFlexGridCellTemplate
        [cellType]="'Cell'"
        let-cell="cell"
        *ngIf="column?.format === 'date-time'"
      >
        {{ cell.item[column.binding] | klDate : true }}
      </ng-template>
      <ng-template
        wjFlexGridCellTemplate
        [cellType]="'Cell'"
        let-cell="cell"
        *ngIf="column?.format === 'password'"
      >
        <span class="password">{{
          makePasswordStar(cell.item[column.binding])
        }}</span>
      </ng-template>
      <ng-template
        wjFlexGridCellTemplate
        [cellType]="'CellEdit'"
        let-cell="cell"
        *ngIf="column?.format === 'date-time'"
      >
        <wj-input-date-time
          [(value)]="cell.value"
          [isRequired]="false"
          [format]="'dd.MM.yyyy HH:mm'"
          (valueChange)="cell.value = $event"
        ></wj-input-date-time>
      </ng-template>
      <ng-template
        wjFlexGridCellTemplate
        [cellType]="'Cell'"
        let-cell="cell"
        *ngIf="column?.format === 'time'"
      >
        {{ cell.item[column.binding] | klDate : false : true }}
      </ng-template>
      <ng-template
        wjFlexGridCellTemplate
        [cellType]="'CellEdit'"
        let-cell="cell"
        *ngIf="column?.format === 'time'"
      >
        <wj-input-time
          [(value)]="cell.value"
          [isRequired]="false"
          [step]="1"
          [format]="'HH:mm'"
          (valueChange)="cell.value = $event"
        ></wj-input-time>
      </ng-template>
      <ng-template
        wjFlexGridCellTemplate
        [cellType]="'Cell'"
        let-cell="cell"
        *ngIf="column.index"
      >
        {{ cell.row.index + 1 }}
      </ng-template>
      <ng-template
        wjFlexGridCellTemplate
        [cellType]="'Cell'"
        let-cell="cell"
        *ngIf="column.buttonAction"
      >
        <a
          role="button"
          class="text-center"
          (click)="column.buttonAction.method(cell)"
        >
          <i class="w-100" [ngClass]="column.icon"></i>
        </a>
      </ng-template>
      <ng-template
        wjFlexGridCellTemplate
        [cellType]="'Cell'"
        let-cell="cell"
        *ngIf="column.translate"
      >
        {{ cell.item[column.binding] | translate }}
      </ng-template>
      <!--      <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell" *ngIf="column.format === 'n2' || column.format === 'n5'">-->
      <!--        <wj-input-number [format]="column.format"-->
      <!--                         [min]="0"-->
      <!--                         [max]="10000"-->
      <!--                         class="form-control form-control-sm"-->
      <!--                         [showSpinner]="false"-->
      <!--                         [(value)]="cell.item[column.binding]"-->
      <!--                         [step]=".01">-->
      <!--        </wj-input-number>-->
      <!--      </ng-template>-->
    </wj-flex-grid-column>
  </wj-flex-grid>
  <wj-menu
    #formGridMenu
    id="form-grid-context-menu"
    (itemClicked)="menuItemClicked(formGridMenu, flexGrid)"
    [dropDownCssClass]="'grid-list-menu'"
    [displayMemberPath]="'header'"
    [hidden]="true"
  >
    <wj-menu-item [value]="'delete'" *ngIf="allowDelete">
      <span class="dropdown-item-icon"></span>
      <span class="grid-dropdown-span">{{ "delete" | translate }}</span>
    </wj-menu-item>
    <wj-menu-item *ngFor="let action of actions" [value]="action.slug">
      <span class="dropdown-item-icon"></span>
      <span class="grid-dropdown-span">{{ action.slug | translate }}</span>
    </wj-menu-item>
  </wj-menu>
</div>
<p-sidebar
  [(visible)]="isSidebarShow"
  position="right"
  styleClass="kl-sidebar position-fixed"
  (onHide)="isSidebarShow = false"
>
  <div class="sidebar-header">
    <label>{{ "processButtons" | translate }}</label>
  </div>
  <tabset>
    <tab [heading]="'grid_design' | translate" id="tab2">
      <a
        role="button"
        class="dropdown-item f-s-14 mt-1 mb-1"
        (click)="setDefaultTemplate()"
      >
        <i class="fal fa-columns" style="color: #9e9e9e" aria-hidden="true"></i>
        {{ "default_design" | translate }}
      </a>
      <a
        role="button"
        class="dropdown-item f-s-14 mt-1 mb-1"
        (click)="saveLayout('add')"
      >
        <i class="fal fa-save" style="color: #9e9e9e" aria-hidden="true"></i>
        {{ "save_design" | translate }}
      </a>
      <accordion style="padding-top: 0">
        <accordion-group
          [isOpen]="isTemplatesOpen"
          (isOpenChange)="isTemplatesOpen = $event"
          [panelClass]="'template-accordion'"
        >
          <div accordion-heading class="clearfix timeline-accordion-header">
            <i class="kalem-icon-buying md"></i
            ><span class="accordion-title"
              >{{ "saved_designs" | translate }}
            </span>
          </div>
          <div style="overflow-y: auto; max-height: 350px">
            <ul class="timeline">
              <li
                *ngFor="let template of templates; let i = index"
                (click)="selectLayout(template, i)"
                [class.active]="template.id === currentTemplate?.id"
              >
                <a role="button" class="dropdown-item position-relative">
                  {{ template.description }}
                </a>
                <span class="process-icons">
                  <i
                    class="fal fa-edit template-process text-success"
                    (click)="saveLayout('edit', template)"
                  ></i>
                  <i
                    class="fal fa-trash template-process text-danger"
                    (click)="deleteLayout(template, i)"
                  ></i>
                </span>
              </li>
            </ul>
          </div>
        </accordion-group>
      </accordion>
    </tab>
    <tab [heading]="'column_add_or_remove' | translate" id="tab1">
      <kl-column-picker
        *ngIf="isSidebarShow"
        [flexGrid]="flexGrid"
      ></kl-column-picker>
    </tab>
  </tabset>
</p-sidebar>
<kl-preference-form (onSetPreference)="commitSave($event)"></kl-preference-form>
